import axios from "../axiosInstance"

export const insertNdaInfo = async ({
  legalName,
  email,
  address,
  city,
  state,
  zip,
  phone,
}: {
  legalName: string
  email: string
  address: string
  city: string
  state: string
  zip: string
  phone: string
}) => {
  try {
    const res = await axios.post("/compliance/nda", {
      legalName,
      email,
      address,
      city,
      state,
      zip,
      phone,
    })

    const { data } = res
    return data.success
  } catch (error) {
    console.error("Error inserting NDA information:", error)
    throw error
  }
}

export const insertBcInfo = async ({
  dealId,
  legalName,
  email,
  address,
  city,
  state,
  zip,
  phone,
  ssn,
  birthDate,
  isMarried,
  isUsCitizen,
  spouseName,
  spouseEmail,
}: {
  dealId: number
  legalName: string
  email: string
  address: string
  city: string
  state: string
  zip: string
  phone: string
  ssn: string
  birthDate: string
  isMarried: string
  isUsCitizen: string
  spouseName?: string
  spouseEmail?: string
}) => {
  try {
    const res = await axios.post("/compliance/bc", {
      dealId,
      legalName,
      clientEmail: email,
      address,
      city,
      state,
      zip,
      phone,
      ssn,
      dob: birthDate,
      isMarried,
      isUsCitizen,
      spouseName,
      spouseEmail,
    })

    const { data } = res
    return data.success
  } catch (error) {
    console.error("Error inserting BC information:", error)
    throw error
  }
}